// eslint-disable-next-line import/extensions
import api from '../api/index';

export default (ctx, inject) => {
    Object.keys(api).forEach((key) => {
        inject(key, api[key](ctx.$axios));
    });
};
